/* Designer Consignor Naples — particles.js
   Ambient drift of the house's OWN iconography (DC cipher, gold flecks,
   1-of-1 ring, key, fleuron, quilted diamond, chain link). No maison marks.
   Reduced-motion: static scatter, no animation. Vanilla, null-safe. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var MOTIFS = {
    dot: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="3" fill="currentColor"/></svg>',
    sparkle: '<svg viewBox="0 0 24 24"><path d="M12 1 L13.4 10.6 L23 12 L13.4 13.4 L12 23 L10.6 13.4 L1 12 L10.6 10.6 Z" fill="currentColor"/></svg>',
    ring1: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10.5" fill="none" stroke="currentColor" stroke-width="1"/><text x="12" y="16.5" text-anchor="middle" font-family="Georgia,serif" font-style="italic" font-size="11" fill="currentColor">1</text></svg>',
    cipher: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10.5" fill="none" stroke="currentColor" stroke-width="1"/><circle cx="12" cy="12" r="8.6" fill="none" stroke="currentColor" stroke-width=".5" opacity=".55"/><text x="9.3" y="16" font-family="Georgia,serif" font-style="italic" font-size="10.5" fill="currentColor">D</text><text x="13" y="16" font-family="Georgia,serif" font-style="italic" font-size="10.5" fill="currentColor">C</text></svg>',
    diamond: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><path d="M12 2 L22 12 L12 22 L2 12 Z"/></svg>',
    chain: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><ellipse cx="9" cy="12" rx="4" ry="6"/><ellipse cx="15" cy="12" rx="4" ry="6"/></svg>',
    key: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"><circle cx="7" cy="7" r="4"/><path d="M10 10 L21 21 M18 18 l2.2 -2.2 M15 15 l2.2 -2.2"/></svg>',
    fleuron: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 3 C9.5 8 3 9 3 12 C3 15 9.5 16 12 21 C14.5 16 21 15 21 12 C21 9 14.5 8 12 3 Z" opacity=".6"/></svg>'
  };
  // weighted bag: gold dust dominates, signatures sprinkle
  var BAG = ['dot','dot','dot','dot','sparkle','sparkle','sparkle','diamond','diamond','ring1','cipher','chain','key','fleuron'];

  function rnd(a, b) { return a + (b - a) * frand(); }
  // deterministic-ish PRNG seeded per index so layout is stable without Math.random
  var seed = 0x9e3779b9;
  function frand() { seed ^= seed << 13; seed ^= seed >>> 17; seed ^= seed << 5; return ((seed >>> 0) % 100000) / 100000; }

  function build(host) {
    var count = parseInt(host.getAttribute('data-particles') || '18', 10);
    if (reduced) count = Math.min(count, 10);
    var frag = document.createDocumentFragment();
    for (var i = 0; i < count; i++) {
      var motif = BAG[Math.floor(frand() * BAG.length)];
      var size = Math.round(rnd(8, 34));
      // ciphers/keys a touch bigger, dots smaller
      if (motif === 'dot') size = Math.round(rnd(4, 9));
      if (motif === 'cipher' || motif === 'ring1') size = Math.round(rnd(18, 36));
      var el = document.createElement('span');
      el.className = 'particle';
      el.style.left = rnd(2, 96).toFixed(2) + '%';
      el.style.top = rnd(4, 92).toFixed(2) + '%';
      el.style.width = size + 'px';
      el.style.height = size + 'px';
      el.style.setProperty('--p-op', rnd(0.05, 0.20).toFixed(3));
      el.style.setProperty('--p-x', Math.round(rnd(-30, 30)) + 'px');
      el.style.setProperty('--p-r', Math.round(rnd(-40, 40)) + 'deg');
      if (!reduced) {
        el.style.animationDuration = rnd(16, 34).toFixed(1) + 's';
        el.style.animationDelay = '-' + rnd(0, 30).toFixed(1) + 's';
      } else {
        el.style.opacity = el.style.getPropertyValue('--p-op');
      }
      el.innerHTML = MOTIFS[motif];
      frag.appendChild(el);
    }
    host.appendChild(frag);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var hosts = Array.prototype.slice.call(document.querySelectorAll('[data-particles]'));
    hosts.forEach(build);
  });
})();
